import React, { useState, useContext } from "react";
import { IconButton } from "@material-ui/core";
import { Sms as SmsIcon } from "@material-ui/icons";
import SendSmsModal from "../SendSmsModal";
import { ModulesContext } from "../../context/Modules/ModulesContext";
import api from "../../services/api";

const ContactSmsButton = ({ contact }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { smsEnabled, smsLoading } = useContext(ModulesContext);

  const handleSmsSuccess = async () => {
    try {
      await api.get("/sms/balance");
    } catch (error) {
      console.log("Erro ao atualizar saldo SMS:", error);
    }
  };

  if (smsLoading || !smsEnabled) {
    return null;
  }

  return (
    <>
      <IconButton
        size="small"
        onClick={() => setModalOpen(true)}
      >
        <SmsIcon style={{ color: "gray" }} />
      </IconButton>

      <SendSmsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        contact={contact}
        onSuccess={handleSmsSuccess}
      />
    </>
  );
};

export default ContactSmsButton;
